// Copyright aptihealth, inc. 2019 All Rights Reserved

import { useState, useEffect, useRef } from "react";

export default function usePopUpVisibility(initialIsVisible) {
    const [isPopUpVisible, setIsPopUpVisible] = useState(initialIsVisible);
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setIsPopUpVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);

    return { ref, isPopUpVisible, setIsPopUpVisible };
}
